import { supabase } from "@/lib/supabase/supabaseClient";
import { AddBankQuestionParams } from ".";

export const addBankQuestion = async ({ question }: AddBankQuestionParams) => {
    const newBankQuestionBody: AddBankQuestionParams['question'] = {
        ...question,
        field_type_context_stack: [
            ...question.field_type_context_stack,
            {
                crm_system: question.crm_system,
                field_type: question.field_type
            }
        ]
    }
    return await supabase
        .from('question_bank')
        .insert(newBankQuestionBody)
        .select()
        .maybeSingle()
        .throwOnError()
        .then(res => res.data);
}